import type { ReactNode } from "react";
import { X } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Dialog, DialogContent } from "@/modern/components/ui/dialog-shadcn";

type FrameProps = {
  gridName: string;
  dayLabel: string;
  onClose: () => void;
  children: ReactNode;
};

export function CheckgridPanelFrame({ gridName, dayLabel, onClose, children }: FrameProps) {
  return (
    <aside className="flex w-[390px] shrink-0 flex-col border-l border-border bg-background">
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-border/40 px-5 py-3.5">
        <nav aria-label="Cell location" className="flex min-w-0 items-center gap-1.5 text-[12.5px] text-muted-foreground">
          <span className="truncate">{gridName}</span>
          {dayLabel && (
            <>
              <span className="size-1.5 shrink-0 rounded-full bg-muted-foreground/50" aria-hidden />
              <span className="shrink-0 text-foreground/80">{dayLabel}</span>
            </>
          )}
        </nav>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="-my-1 -mr-1.5 size-7 shrink-0 text-muted-foreground hover:bg-muted/50 hover:text-foreground"
          onClick={onClose}
          aria-label="Close"
        >
          <X className="size-4" />
        </Button>
      </div>
      {children}
    </aside>
  );
}

export function EvidenceViewer({ src, alt, onClose }: { src: string | null; alt: string; onClose: () => void }) {
  return (
    <Dialog open={src !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="z-[--swivu-bryntum-z-index] sm:max-w-3xl">{src && <img src={src} alt={alt} className="max-h-[80vh] w-full rounded-lg object-contain" />}</DialogContent>
    </Dialog>
  );
}
